import React, { useState, useEffect, useRef } from 'react';
import ProductShop from '../components/ProductShop';

const BrandsPage = ({ lang }) => {
  const [selectedBrand, setSelectedBrand] = useState(null);
  const isRtl = lang === 'ar';
  
  // مرجع (Ref) لتحديد مكان بداية قسم المتجر بالضبط
  const shopViewRef = useRef(null);

  const myBrands = [
    { name: "Baseel", ar: "بسيل", logo: "/images/logos/baseel.JPG", color: "#1a3a5a" },
    { name: "Rghawy", ar: "رغاوي", logo: "/images/logos/rghawy.png", color: "#d4af37" },
    { name: "XClor", ar: "إكس كلور", logo: "/images/logos/xclor.JPG", color: "#1a3a5a" },
    { name: "Mival", ar: "ميفال", logo: "/images/logos/mival.JPG", color: "#d4af37" },
    { name: "Tany", ar: "تاني", logo: "/images/logos/tany.JPG", color: "#1a3a5a" },
    { name: "C-Plus", ar: "سي بلاس", logo: "/images/logos/cplus.JPG", color: "#d4af37" }
  ];

  // التعديل السحري هنا: بدلاً من الصعود لأعلى الصفحة، سنركز على بداية المتجر
  useEffect(() => {
    if (selectedBrand && shopViewRef.current) {
      // ننتظر الريندر البسيط ثم نوجه الشاشة لبداية قسم المنتجات
      const offset = 80; // تعويض بسيط عشان الهيدر ما يغطي زر الرجوع
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = shopViewRef.current.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }, [selectedBrand]);

  if (selectedBrand) {
    return (
      <div 
        ref={shopViewRef} // نربط المرجع هنا
        id="yam-store-view" 
        style={{ position: 'relative', animation: 'fadeIn 0.5s ease' }}
      >
        <div style={styles.backNav}>
          <button 
            onClick={() => setSelectedBrand(null)} 
            style={styles.backButton}
          >
            {isRtl ? "🔙 العودة لجميع الماركات" : "🔙 Back to All Brands"}
          </button>
        </div>
        <ProductShop lang={lang} filterBrand={selectedBrand} />
      </div>
    );
  }

  return (
    <section id="yamshop" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.headerBox}>
          <h2 style={styles.mainTitle}>
            {isRtl ? "عائلة ماركات يـام" : "Yam Brands Family"}
          </h2>
          <div style={styles.underline}></div>
          <p style={styles.subtitle}>
            {isRtl ? "اختر علامتك التجارية المفضلة لتصفح منتجاتها" : "Choose your favorite brand to browse its products"}
          </p>
        </div>

        <div style={styles.grid}>
          {myBrands.map((brand, index) => (
            <div 
              key={index} 
              style={styles.card} 
              className="brand-card-hover"
              onClick={() => setSelectedBrand(brand)}
            >
              <div style={styles.logoWrapper}>
                <img src={brand.logo} alt={brand.name} style={styles.logoImg} />
              </div>
              <div style={styles.infoBox}>
                <h3 style={styles.brandNameEn}>{brand.name}</h3>
                <h4 style={styles.brandNameAr}>{brand.ar}</h4>
              </div>
              <div style={styles.cardFooter}>
                <span>{isRtl ? "تسوق الآن" : "Shop Now"}</span>
                <span style={{fontSize: '18px'}}>{isRtl ? '←' : '→'}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .brand-card-hover { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); cursor: pointer; }
        .brand-card-hover:hover { transform: translateY(-8px); border-color: #d4af37 !important; box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important; }
      `}</style>
    </section>
  );
};

// ... (نفس الستايلات السابقة دون تغيير)
const styles = {
  section: { padding: '80px 5%', backgroundColor: '#ffffff', minHeight: '80vh' },
  container: { maxWidth: '1200px', margin: '0 auto' },
  headerBox: { textAlign: 'center', marginBottom: '50px' },
  mainTitle: { color: '#1a3a5a', fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', fontWeight: '800', marginBottom: '10px' },
  underline: { width: '60px', height: '4px', background: '#d4af37', margin: '0 auto 20px', borderRadius: '2px' },
  subtitle: { color: '#666', fontSize: '1rem' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '25px' },
  card: { background: '#fff', borderRadius: '20px', padding: '25px', cursor: 'pointer', border: '1px solid #f0f0f0', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  logoWrapper: { width: '120px', height: '120px', borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px', border: '1px solid #eee', padding: '10px', overflow: 'hidden' },
  logoImg: { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' },
  infoBox: { textAlign: 'center', marginBottom: '15px' },
  brandNameEn: { color: '#1a3a5a', fontSize: '1.2rem', fontWeight: 'bold', margin: '0 0 5px 0' },
  brandNameAr: { color: '#d4af37', fontSize: '1rem', margin: 0 },
  cardFooter: { marginTop: 'auto', display: 'flex', alignItems: 'center', gap: '10px', color: '#1a3a5a', fontWeight: '600', fontSize: '0.85rem', borderTop: '1px solid #f9f9f9', paddingTop: '15px', width: '100%', justifyContent: 'center' },
  backNav: { padding: '15px 5%', backgroundColor: '#f8f9fb', borderBottom: '1px solid #eee' },
  backButton: { padding: '10px 20px', background: '#1a3a5a', color: '#fff', border: 'none', borderRadius: '50px', cursor: 'pointer', fontWeight: 'bold' }
};

export default BrandsPage;